export default "assets/images/icons/arrow-down-b0bad5fe.svg";